// External URL normalization helpers.
//
// Restaurant owners enter websites in many formats:
//   "www.ember.de"        →  "https://www.ember.de"
//   "ember.de"            →  "https://ember.de"
//   "https://ember.de"    →  "https://ember.de"
//   "http://ember.de"     →  "http://ember.de"     (kept as-is)
//   ""  /  null           →  ""                   (no link)
//
// Without normalisation, a raw value like "www.ember.de" used in <a href=...>
// is interpreted as a relative path and routes through the SPA — producing
// URLs like "https://qrmenu-pro.com/m/www.ember.de" which is wrong.

export function normalizeExternalUrl(raw) {
  if (!raw || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";
  // Already absolute — keep as-is (preserve http vs https)
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Mailto / tel / sms etc — keep as-is
  if (/^(mailto:|tel:|sms:|whatsapp:)/i.test(trimmed)) return trimmed;
  // Anything else (www.ember.de, ember.de, sub.example.com/path) → prepend https://
  return `https://${trimmed.replace(/^\/+/, "")}`;
}

// Convenience: returns the props you can spread on any <a> tag pointing to an
// external website — handles normalisation, target=_blank, and rel security.
export function externalLinkProps(raw) {
  const href = normalizeExternalUrl(raw);
  if (!href || /^(mailto:|tel:|sms:|whatsapp:)/i.test(href)) {
    return { href };
  }
  return {
    href,
    target: "_blank",
    rel: "noopener noreferrer",
  };
}
